import React from 'react';
import { TextField as MUITextField, Radio as MUIRadio } from '@material-ui/core';

export const TextField = props => <MUITextField InputLabelProps={{shrink:true}} {...props.field} {...props} />
export const Radio = props => <MUIRadio {...props.field} {...props} />